module.exports = __webpack_public_path__ + "static/Triangular-Triangle-46c93cf35d7d2b1a8876e9a81dc7347f.webp";